import $ from 'jquery';
const $doc = $(document);
const loader = `<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="110px" height="110px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
<circle cx="50" cy="50" fill="none" stroke="#013766" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.0204081632653061s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
</circle>`;

$doc.on('click', '.js-clients-pagination a', initPagination )
$doc.on('click', '.js-clients .js-clients-item', initTabs )
const tabContent = $('.clients__wrapper');

function initPagination(e) {
  e.preventDefault();
  let page = parseInt($(this).html());
  let currentPage = parseInt($('.page-numbers.current').html());
  if($(this).hasClass('next')) {
    page = currentPage + 1;
  }
  if($(this).hasClass('prev')) {
    page = currentPage - 1;
  }
  if($(this).hasClass('current')) {
    return;
  }
  toggleTabs(e,page);
}

function initTabs(e) {
  e.preventDefault();
  if(!$(this).hasClass('active')) {
    $(this).addClass('active').attr('aria-selected', 'true').removeAttr('tabindex')
    $('.js-clients-item').not(this).removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
  }
  toggleTabs(e,1);
}

function toggleTabs(e,page) {
  e.preventDefault();
  const category = $('.js-clients-item.active').attr('data-cat');
  const data = {
    action : "toggle_tabs",
    cat : category,
    page : page,
  }

  tabContent.empty();
  return $.ajax({
    url : php_vars.ajax_url,
    data : data,
    beforeSend: function () {
      tabContent.attr('aria-busy', 'true').append(loader)
    },
    success : function(response) {
      tabContent.attr('aria-busy', 'false').html(response);
    }
  });
}

$(document).on('keydown', '.js-clients .js-clients-item', function(ev) {
  const navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
  if (!navigationKeys.includes(ev.key)) {
    return;
  }

  const $tabs = $(this).closest('.js-clients').find('.js-clients-item');
  const tabs = $tabs.get();
  const index = tabs.indexOf(this);
  if (index < 0) {
    return;
  }

  let next = index;
  switch (ev.key) {
    case 'ArrowLeft':
    case 'ArrowUp':
      next = index === 0 ? tabs.length - 1 : index - 1;
      break;
    case 'ArrowRight':
    case 'ArrowDown':
      next = index === tabs.length - 1 ? 0 : index + 1;
      break;
    case 'Home':
      next = 0;
      break;
    case 'End':
      next = tabs.length - 1;
      break;
  }

  ev.preventDefault();
  $(tabs[next]).trigger('focus').trigger('click');
});